import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import companyReducer from './companyReducer';
import paymentsReducer from './paymentsReducer';
import subsidiariesReducer from './subsidiariesReducer';
import emailQueueReducer from './emailQueueReducer';
import loadingReducer from './loadingReducer';
import employeesReducer from './employeesReducer';
import menuReducer from './menuReducer';
import fileReducer from './fileReducer';
import modalReducer from './modalReducer';
import toastsReducer from './toastsReducer';
import liquidationListReducer from './liquidationListReducer';
import superAdminReducer from './superAdminReducer';
import bankReducer from './bankReducer';
import dataChangeRequestsReducer from './dataChangeRequests/dataChangeRequestsReducer';
import { zeusApiV1, zeusApi, zeusSuperApi, superApi, commonApi, api } from 'src/store/api';

const appReducer = combineReducers({
  [commonApi.reducerPath]: commonApi.reducer,
  [zeusApiV1.reducerPath]: zeusApiV1.reducer,
  [zeusApi.reducerPath]: zeusApi.reducer,
  [zeusSuperApi.reducerPath]: zeusSuperApi.reducer,
  [superApi.reducerPath]: superApi.reducer,
  [api.reducerPath]: api.reducer,
  session: sessionReducer,
  company: companyReducer,
  companySubsidiaries: subsidiariesReducer,
  payments: paymentsReducer,
  emailQueue: emailQueueReducer,
  loading: loadingReducer,
  employees: employeesReducer,
  menu: menuReducer,
  file: fileReducer,
  modal: modalReducer,
  toasts: toastsReducer,
  liquidationList: liquidationListReducer,
  superAdmin: superAdminReducer,
  bank: bankReducer,
  dataChangeRequests: dataChangeRequestsReducer
});

const CLEAN_EVENTS = ['SESSION_LOGOUT', 'CLEAN_STORE'];

const rootReducer = (state, action) => {
  if (CLEAN_EVENTS.includes(action.type)) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
